import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { SuiToasterComponent } from '@stride-ui/components';
import {
  GtmTrackingService,
  LanguageService,
  RobotsMetaService,
  SeoMetaService,
} from '@tnq/shared/core';
import { environment } from '../environments/environment';

@Component({
  imports: [RouterModule, SuiToasterComponent],
  selector: 'tnq-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly languageService = inject(LanguageService);
  private readonly gtmTrackingService = inject(GtmTrackingService);
  private readonly robotsMetaService = inject(RobotsMetaService);
  private readonly seoMetaService = inject(SeoMetaService);

  ngOnInit(): void {
    this.languageService.initialize();
    this.gtmTrackingService.initialize();
    this.robotsMetaService.initialize(environment);
    this.seoMetaService.initialize();
  }
}
